export default {
  initialize: 'initialize',
  updateMobileNumber: 'updateMobileNumber',
  mobileInvalid: 'mobileInvalid',
};



// WEBPACK FOOTER //
// ./components/transaction/src/actions/onPaymentEnterMobile/actionType.js